import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { Bell, Check, AlertTriangle, Info, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ICONS = { info: Info, success: CheckCircle, warning: AlertTriangle, error: AlertTriangle };
const COLORS = { info: "#3B82F6", success: "#10B981", warning: "#F59E0B", error: "#EF4444" };

export default function Notifications() {
  const { lang } = useLanguage();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

  const load = async () => { const r = await api.get(`/notifications${filter === "unread" ? "?unread_only=true" : ""}`); setItems(r.data); };
  useEffect(() => { load(); }, [filter]);

  const markAllRead = async () => { await api.put("/notifications/mark-all-read"); load(); };
  const markRead = async (id, link) => {
    await api.put(`/notifications/${id}/read`);
    if (link) navigate(link);
    else load();
  };

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-3xl font-heading gold-text">{lang === "ar" ? "الإشعارات" : "Notifications"}</h1>
        <div className="flex gap-2 items-center">
          <button onClick={() => setFilter(filter === "all" ? "unread" : "all")} className="px-3 py-1.5 border rounded-md text-sm">{filter === "all" ? (lang === "ar" ? "غير المقروءة فقط" : "Unread only") : (lang === "ar" ? "كل الإشعارات" : "All")}</button>
          <button data-testid="mark-all-read-btn" onClick={markAllRead} className="px-3 py-1.5 bg-[var(--gold)] text-white rounded-md text-sm">{lang === "ar" ? "تعليم الكل كمقروء" : "Mark all read"}</button>
        </div>
      </div>

      <div className="bg-[var(--surface)] border border-[var(--border)] rounded-xl divide-y divide-[var(--border)]">
        {items.map((n) => {
          const Icon = ICONS[n.type] || Info;
          return (
            <div key={n.notification_id} onClick={() => markRead(n.notification_id, n.link)} className={`p-4 flex items-start gap-3 cursor-pointer hover:bg-[var(--bg)] transition ${!n.read ? "bg-[var(--gold)]/5" : ""}`}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: `${COLORS[n.type]}20`, color: COLORS[n.type] }}>
                <Icon size={18} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-[var(--text)]">{n.title}</span>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-[var(--gold)]" />}
                </div>
                <p className="text-sm text-[var(--text-muted)] mt-0.5">{n.body}</p>
                <span className="text-xs text-[var(--text-muted)] mt-1 block">{new Date(n.created_at).toLocaleString()}</span>
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div className="text-center text-[var(--text-muted)] py-12"><Bell className="mx-auto mb-2" /> {lang === "ar" ? "لا توجد إشعارات" : "No notifications"}</div>}
      </div>
    </div>
  );
}
